<script>
  export let value;
  let strDate;
  let date;

  function parseDate() {
    if (!strDate) return;
    const [year, month, day, hour, min] = strDate.split(/[-T:]/).map(d => Number(d));
    date = new Date(year, month - 1, day, hour, min);
    value = date.toISOString();
  }

  function renderDate() {
    if (!value) return;
    date = new Date(Date.parse(value));
    const d = [date.getFullYear(),
      ...[
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      ].map((e) => ('0' + e).slice(-2))];
    strDate = `${d[0]}-${d[1]}-${d[2]}T${d[3]}:${d[4]}`;
  }

  $: value, renderDate();

  $: strDate, parseDate();

  import {Input} from 'sveltestrap';

</script>

<Input type="datetime-local" bind:value={strDate}/>
